import { render, staticRenderFns } from "./Navyxion.vue?vue&type=template&id=327444e5&"
import script from "./Navyxion.vue?vue&type=script&lang=js&"
export * from "./Navyxion.vue?vue&type=script&lang=js&"
import style0 from "./Navyxion.vue?vue&type=style&index=0&id=327444e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports